export default __webpack_public_path__ + "static/media/daily_dose_reminder_active.4f898e64.svg";